import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, Dna, Plus, Trash2, Save } from "lucide-react";

export default function MappingConfig() {
  const [mappings, setMappings] = useState(null);
  const [savingId, setSavingId] = useState(null);

  const load = async () => {
    const { data } = await api.get("/mappings");
    setMappings(data.mappings);
  };
  useEffect(() => { load(); }, []);

  if (!mappings) return <div className="flex justify-center py-20"><Loader2 className="h-6 w-6 animate-spin text-brand" /></div>;

  const update = (ci, idx, key, val) => {
    setMappings((m) => m.map((x) => x.condition_id !== ci ? x : {
      ...x, tests: x.tests.map((t, i) => i === idx ? { ...t, [key]: val } : t),
    }));
  };
  const addRow = (ci) => setMappings((m) => m.map((x) => x.condition_id !== ci ? x : { ...x, tests: [...x.tests, { gene: "", test: "" }] }));
  const delRow = (ci, idx) => setMappings((m) => m.map((x) => x.condition_id !== ci ? x : { ...x, tests: x.tests.filter((_, i) => i !== idx) }));

  const save = async (m) => {
    setSavingId(m.condition_id);
    try {
      await api.put(`/mappings/${m.condition_id}`, { tests: m.tests.filter((t) => t.gene && t.test) });
      toast.success(`${m.condition_name} mapping saved`);
    } catch (e) { toast.error(e.response?.data?.detail || "Failed"); }
    finally { setSavingId(null); }
  };

  return (
    <div className="max-w-4xl">
      <div className="eyebrow">Configuration</div>
      <h1 className="font-head text-3xl font-bold text-ink mt-1">Voice → Genetic test mapping</h1>
      <p className="text-ink-soft mt-1">Configurable per condition — never hardcoded. Applied when triage is Moderate or High.</p>

      <div className="mt-6 space-y-4">
        {mappings.map((m) => (
          <div key={m.condition_id} className="rounded-xl border border-slate-200 bg-white p-5" data-testid={`mapping-${m.condition_id}`}>
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Dna className="h-4.5 w-4.5 h-[18px] w-[18px] text-brand" />
                <h3 className="font-head font-semibold text-ink">{m.condition_name}</h3>
              </div>
              <button onClick={() => save(m)} disabled={savingId === m.condition_id} data-testid={`save-mapping-${m.condition_id}`}
                className="inline-flex items-center gap-1.5 rounded-lg bg-brand text-white px-3.5 py-1.5 text-sm font-semibold hover:bg-brand-hover transition-colors disabled:opacity-50">
                {savingId === m.condition_id ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Save className="h-3.5 w-3.5" />} Save
              </button>
            </div>
            <div className="mt-3 space-y-2">
              {m.tests.map((t, i) => (
                <div key={i} className="flex items-center gap-2">
                  <input value={t.gene} onChange={(e) => update(m.condition_id, i, "gene", e.target.value)} placeholder="Gene"
                    className="w-28 rounded-lg border border-slate-300 px-3 py-2 text-sm mono outline-none focus:border-brand" />
                  <input value={t.test} onChange={(e) => update(m.condition_id, i, "test", e.target.value)} placeholder="Test name"
                    className="flex-1 rounded-lg border border-slate-300 px-3 py-2 text-sm outline-none focus:border-brand" />
                  <button onClick={() => delRow(m.condition_id, i)} className="text-ink-muted hover:text-red-600 p-2">
                    <Trash2 className="h-4 w-4" />
                  </button>
                </div>
              ))}
              <button onClick={() => addRow(m.condition_id)} className="inline-flex items-center gap-1.5 text-sm font-medium text-brand hover:underline mt-1">
                <Plus className="h-4 w-4" /> Add test
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
